import type { Employee } from '@/types'

export const useEmployees = () => {
  function getColorClass(index: number): string {
    return `bg-list-${(index % 13) + 1}`
  }

  function shortName(name: string) {
    return name
      .split(' ')
      .map(n => Array.from(n)[0])
      .slice(0, 2)
      .join('')
  }

  function hasClockedIn(employee: Employee) {
    return Boolean(employee.clockIn) && !employee.clockOut
  }

  return {
    getColorClass,
    shortName,
    hasClockedIn
  }
}
